import React from 'react'
import BgImage from '../../assets/images/Backgrounds/wellness-bg-5.jpg';

const Background1 = () => {
    return (
        <div
            className="sticky top-0 -z-50 h-screen opacity-75"
            style={{
                backgroundImage: `url(${BgImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
            }}
        >
        </div>
    )
}

export default Background1